import type { ExtractPropTypes, PropType, InjectionKey, Ref } from 'vue'

export type RadioSize = 'large' | 'default' | 'small'

export interface RadioGroupContext {
  name: Ref<string>
  modelValue: Ref<string | number | boolean>
  disabled: Ref<boolean>
  size: Ref<RadioSize | ''>
  onChange: (val: string | number | boolean) => void
}

export const radioGroupKey: InjectionKey<RadioGroupContext> = Symbol('radioGroupKey')

export const radioProps = {
  /**
   * 单选框的值
   */
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  /**
   * 单选框的值
   */
  label: {
    type: [String, Number, Boolean],
    default: ''
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 单选框的尺寸
   */
  size: {
    type: String as PropType<RadioSize>,
    default: ''
  },
  /**
   * 单选框的名称
   */
  name: {
    type: String,
    default: ''
  },
  /**
   * 是否显示边框
   */
  border: {
    type: Boolean,
    default: false
  }
} as const

export const radioEmits = {
  'update:modelValue': (val: string | number | boolean) => true,
  'change': (val: string | number | boolean) => true
}

export type RadioProps = ExtractPropTypes<typeof radioProps>
export type RadioEmits = typeof radioEmits